// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__dZQSW","title":"InfoRow_title__wpgLm"};